import { render } from "./SwitchBrowseItem.vue?vue&type=template&id=871629a4"
import script from "./SwitchBrowseItem.vue?vue&type=script&lang=js"
export * from "./SwitchBrowseItem.vue?vue&type=script&lang=js"
script.render = render

export default script